import { NgModule } from "@angular/core";
import { TwigCreateModule } from "./create/twig-create.module";
import { TwigListModule } from "./list/twig-list.module";
import { TwigRoutingModule } from "./twig.routing";

@NgModule({
    imports: [TwigRoutingModule, TwigListModule, TwigCreateModule],
})
export class TwigModule {}
